import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const PhoneConfirmedIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "phone-confirmed",
  "PhoneConfirmedIcon",
  ["black","#00A870","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M2.6665 0.666626H12.6665V8.33329C12.199 8.33329 11.7502 8.4135 11.3332 8.5609V1.99996H3.99984V14H9.0292C9.26405 14.5117 9.60371 14.9653 10.0207 15.3333H2.6665V0.666626Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M8.33545 11.3334H6.99951V12.6693H8.33545V11.3334Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M9.6665 12.3333C9.6665 10.6765 11.0096 9.33331 12.6665 9.33331C14.3234 9.33331 15.6665 10.6765 15.6665 12.3333C15.6665 13.9902 14.3234 15.3333 12.6665 15.3333C11.0096 15.3333 9.6665 13.9902 9.6665 12.3333Z" fill={colorList[1]} fillRule="evenodd" clipRule="evenodd"/><path d="M14.4598 11.6666L12.3329 13.7936L10.8726 12.3333L11.4995 11.7063L12.3329 12.5397L13.8329 11.0397L14.4598 11.6666Z" fill={colorList[2]} fillRule="evenodd" clipRule="evenodd"/></g></svg>
);

export default PhoneConfirmedIcon;
